import { Modal } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SModal = styled(Modal)`
  &&.ant-modal {
    .ant-modal-content {
      .ant-modal-body {
        padding: 24px;
      }
      .ant-modal-close {
        inset-inline-start: revert;
        top: 25px;
      }
      .ant-modal-footer {
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    &&.ant-modal {
      width: 100vw !important;
      max-width: 100vw !important;
      margin: 0;
      top: 0;
      padding: 0;

      .ant-modal-content {
        width: 100vw !important;
        height: auto !important;
        max-height: 100vh !important;
        display: flex;
        flex-direction: column;
        border-radius: 0;
        overflow: hidden;

        .ant-modal-body {
          flex: 1 1 auto;
          overflow-y: auto;
          padding: 24px;
          padding-bottom: calc(24px + env(safe-area-inset-bottom));
        }

        .ant-modal-close {
          inset-inline-start: revert;
          top: 25px;
        }
      }
    }
  }
`;
